import { DBSystemCode, DBSystemAvatarIconMap, DBSystemIconMap, DBSystemNameI18nKeyMap } from '@home/_config/config';

import type { TDBSystemCode } from '@home/types/aiSearch';

interface ISystemMessageDescriptor {
  id: string;
  defaultMessage?: string;
}

interface IGetUrlCollectionSystemDisplayInfoOptions {
  system?: TDBSystemCode | '';
  formatMessage: (descriptor: ISystemMessageDescriptor) => string;
  fallbackMessage?: ISystemMessageDescriptor;
  benchmarkMessage?: ISystemMessageDescriptor;
}

interface IUrlCollectionSystemDisplayInfo {
  systemAvatarIcon: string;
  systemIcon: string;
  systemName: string;
}

const DEFAULT_FALLBACK_MESSAGE = {
  id: 'dbh_databrain',
  defaultMessage: 'DataBrain',
};

const DEFAULT_BENCHMARK_MESSAGE = {
  id: 'dbh_benchmark',
  defaultMessage: 'Benchmark',
};

export const getUrlCollectionSystemDisplayInfo = (
  options: IGetUrlCollectionSystemDisplayInfoOptions,
): IUrlCollectionSystemDisplayInfo => {
  const {
    system = '',
    formatMessage,
    fallbackMessage = DEFAULT_FALLBACK_MESSAGE,
    benchmarkMessage = DEFAULT_BENCHMARK_MESSAGE,
  } = options;
  const systemAvatarIcon = system ? DBSystemAvatarIconMap[system] || '' : '';
  const systemIcon = system ? DBSystemIconMap[system] || '' : '';

  if (system === DBSystemCode.Benchmark) {
    return {
      systemAvatarIcon,
      systemIcon,
      systemName: formatMessage(benchmarkMessage),
    };
  }

  const systemTextId = system ? DBSystemNameI18nKeyMap[system] || '' : '';

  return {
    systemAvatarIcon,
    systemIcon,
    systemName: systemTextId ? formatMessage({ id: systemTextId }) : formatMessage(fallbackMessage),
  };
};
